<app-breadcrumb [title]="'Notice Board'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header border-0">
          <div class="d-flex justify-content-end">
            <a routerLink="/admin/notice-boards/new" class="btn btn-primary rounded-0">New Notice
              Board</a>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table align-items-center table-hover">
              <colgroup>
                <col style="width: 10%">
                <col style="width: 40%">
                <col style="width: 10%">
                <col style="width: 10%">
                <col style="width: 10%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i-bs *ngIf="query.sort === c.key" [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'" width="1em" height="1em"></i-bs>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of queryResult.items; let i=index;">
                  <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                  <td [innerHtml]="v.content"></td>
                  <td>{{ v.isActive }}</td>
                  <td>{{ v.updatedAt | date }}</td>
                  <td>
                    <a class="btn btn-sm" [routerLink]="['/admin/notice-boards/edit', v.id]"><i-bs name="pencil-square" width="1em" height="1em"></i-bs></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</div>